import { render, staticRenderFns } from "./EditPayment.vue?vue&type=template&id=04608ec7&"
import script from "./EditPayment.vue?vue&type=script&lang=js&"
export * from "./EditPayment.vue?vue&type=script&lang=js&"
import style0 from "./EditPayment.vue?vue&type=style&index=0&id=04608ec7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports